import { AllergenCode } from '@local-types/products/codes'

export interface AllergenFilter {
	id: string
	value: AllergenCode[]
	label: string
	slug: string
	main: boolean
}

export const allergenFilterList: AllergenFilter[] = [
	{ id: '1', value: ['AW', 'GK', 'GO', 'GB', 'NR', 'UW', 'GS'], label: 'Glútein', slug: 'glutein', main: true },
	{
		id: '2',
		value: ['SA', 'SE', 'SR', 'SC', 'SN', 'SH', 'SI', 'SM', 'SP', 'ST', 'SJ', 'SQ', 'AN', 'SW'],
		label: 'Hnetur',
		slug: 'hnetur',
		main: true,
	},
	{ id: '3', value: ['AP'], label: 'Jarðhnetur', slug: 'jardhnetur', main: true },
	{ id: '4', value: ['AY'], label: 'Soja', slug: 'soja', main: true },
	{ id: '5', value: ['AM', 'ML'], label: 'Mjólk', slug: 'mjolk', main: true },
	{ id: '6', value: ['AE'], label: 'Egg', slug: 'egg', main: true },
	{ id: '7', value: ['NE'], label: 'Baunir', slug: 'baunir', main: false },
	{ id: '8', value: ['AF'], label: 'Fiskur', slug: 'fiskur', main: false },
	{ id: '9', value: ['AC'], label: 'Krabbadýr', slug: 'krabbadyr', main: false },
	{ id: '10', value: ['UM'], label: 'Lindýr', slug: 'lindyr', main: false },
	{ id: '11', value: ['NL'], label: 'Lúpínur', slug: 'lupinur', main: false },
	{ id: '12', value: ['BC'], label: 'Sellerí', slug: 'selleri', main: false },
	{ id: '13', value: ['AS'], label: 'Sesamfræ', slug: 'sesamfrae', main: false },
	{ id: '14', value: ['BM'], label: 'Sinnep', slug: 'sinnep', main: false },
	{ id: '15', value: ['AU'], label: 'Súlfít', slug: 'sulfit', main: false },
]
